export default __webpack_public_path__ + "static/ducking-be284bafaabe0b85c34d6c2a44edb45c.svg";